import { render, staticRenderFns } from "./OrderPreviewVatGroup.vue?vue&type=template&id=02858dae&scoped=true"
import script from "./OrderPreviewVatGroup.vue?vue&type=script&lang=ts"
export * from "./OrderPreviewVatGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02858dae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02858dae')) {
      api.createRecord('02858dae', component.options)
    } else {
      api.reload('02858dae', component.options)
    }
    module.hot.accept("./OrderPreviewVatGroup.vue?vue&type=template&id=02858dae&scoped=true", function () {
      api.rerender('02858dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/OrderPreviewVatGroup.vue"
export default component.exports